import { StaticPropertyKey } from '@bvi/api-interfaces/entity/case-property';
import { IAutocompleteValue } from '@bvi/common-components';

import { OnOptionsLoad } from './types';

export const dedupeOrganizationTypeValues = (
  values: Array<{ id: number; name: string }>,
): Array<{ id: number; name: string }> =>
  values.filter(
    (item, index, self) =>
      index === self.findIndex((entry) => entry.id === item.id),
  );

export async function fetchAllOrganizationTypes(
  onOptionsLoad: OnOptionsLoad,
): Promise<Array<IAutocompleteValue>> {
  let allOrgTypes: Array<IAutocompleteValue> = [];
  let currentPage = 1;
  let hasMorePages = true;

  while (hasMorePages) {
    const response = await onOptionsLoad(StaticPropertyKey.ORGANIZATION_TYPE, {
      page: currentPage,
      search: '',
    });

    const pageData = response?.data?.payload?.data ?? [];
    allOrgTypes = [...allOrgTypes, ...pageData];

    const meta = response?.data?.payload?.meta;
    if (meta?.totalPages) {
      hasMorePages = currentPage < meta.totalPages;
      currentPage++;
    } else {
      hasMorePages = false;
    }
  }

  return allOrgTypes;
}

export const mapOrganizationTypeValues = (
  orgTypes: Array<IAutocompleteValue>,
): Array<{ id: number; name: string }> =>
  orgTypes.map((orgType) => ({
    id: typeof orgType.id === 'number' ? orgType.id : Number(orgType.id),
    name: orgType.name ?? '',
  }));
